import React, { useEffect, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';

import MorningIcon from "assets/icons/morning.svg";
import AfternoonIcon from "assets/icons/afternoon.svg";
import EveningIcon from "assets/icons/evening.svg";
import NightIcon from "assets/icons/night.svg";
import moment from "moment";
import JobUserTag from "./JobUserTag";
import AppDialog from "components/Dialog/AppDialog";
import { BOOKING_STATUS, SHIFT_COLOR } from "../../../../config/AppConfig";
import { getWorkerToBooking } from "store/slices/job";
import { useDispatch } from "react-redux";
import { reduceCalculatePrice } from "store/slices/rate";
import AppButton from "components/CustomButtons/AppButton";
import AppUtil from "utilities/AppUtil";
import { bookWorkerForJob } from "store/slices/job";
import Tooltip from '@material-ui/core/Tooltip';

const styles = makeStyles(() => ({
  marginVertical: {
    marginTop: '100px',
    marginBottom: '100px'
  },
  success: {
    fontSize: '7rem',
    color: AppColor.mainColor,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem',
    '& .title-success': {
      fontSize: '1rem',
      color: AppColor.black,
      marginTop: '2rem'
    },
    '& .message-success': {
      color: AppColor.black,
      fontSize: '0.8rem',
      marginTop: '0rem'
    }
  },
  calendarPage: {
    '& .fc-timegrid-event': {
      cursor: 'pointer',
      width: 'auto'
      // height: 'max-content'
      // backgroundColor: 'unset',
      // border: 'unset'
    },
    '& .fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > *': {
      top: -17
    },
    '& .fc .fc-timegrid-col.fc-day-today': {
      backgroundColor: AppColor.mainLight
    },
    '& .fc-timegrid-slots tr': {
      height: '35px',
      // width: '100%'
    },
    '& .fc-timegrid-event-harness .fc-timegrid-event-harness-inset': {
      width: 155
    }
  },
  wrapEstimate: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: 4,
    padding: '0.5rem',
    margin: '0.5rem 0',
    display: 'flex',
    maxWidth: 500,
    flex: '1 0 0px'
  },
  bold: {
    fontWeight: 700
  },
  control: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '1rem'
  },
  jobCalendarContainer: {
    height: 'calc(100% - 1px)',
    '&.MORNING': {
      backgroundColor: SHIFT_COLOR.MORNING
    },
    '&.AFTERNOON': {
      backgroundColor: SHIFT_COLOR.AFTERNOON
    },
    '&.EVENING': {
      backgroundColor: SHIFT_COLOR.EVENING
    },
    '&.NIGHT': {
      backgroundColor: SHIFT_COLOR.NIGHT
    }
  },
  jobCalendar: {
    display: "flex",
    justifyContent: 'space-around',
    flexDirection: "column",
    color: '#fff'
  },
  svgSmall: {
    width: 16,
    height: 16,
  },
  svgNormal: {
    width: 22,
    height: 22,
  },
  itemIcon: {
    maskSize: '100%',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    backgroundColor: "#ffffff",
  }
}));

const JobCalendar = (props) => {
  const {
    // startDate,
    // endDate,
    calendar: { firstWeekDay, lastWeekDay, weekNum } = {},
    schedule = [],
    // setShowBookingWorker,
    // workersApplied,
    jobId,
    jobDetail,
    reloadCalendar,
    reloadJob,
    setSelectedWeek,
    cacheSelectedWeek,
    // selectedYear
  } = props;
  const { t } = useTranslation();
  const classes = styles();
  const dispatch = useDispatch();

  const [events, setEvents] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState();
  const [showWorkerTag, setShowWorkerTag] = useState(false);
  const [workerBooking, setWorkerBooking] = useState([]);
  const [showOptionBooking, setShowOptionBooking] = useState(false);
  const [selectedShift, setSelectedShift] = useState();
  const [estimate, setEstimate] = useState(null);
  const [selectedDate, setSelectedDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedWeekNum, setSelectedWeekNum] = useState();
  const [selectedWorkerBooking, setSelectedWorkerBooking] = useState();
  const [reload, setReload] = useState(false);
  const [jobAvailabilityId, setJobAvailabilityId] = useState();
  const [titleBooking, setTitleBooking] = useState();
  const [selectedYear, setSelectedYear] = useState();

  const startDate = firstWeekDay ? firstWeekDay.format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
  const endDate = lastWeekDay ? moment(lastWeekDay).add(1, 'days').format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
  const dateRange = {
    start: startDate,
    end: endDate
  };

  const {
    jobAvailabilities,
    specialty,
    support,
    accreditation,
    jobType
  } = jobDetail;

  const bookingColor = {
    'BOOKED': { color: AppColor.green },
    'ON_GOING': { color: AppColor.violet },
    'CANCEL': { color: AppColor.red },
    'DONE': { color: AppColor.mainBlue },
    'WAITING': { color: AppColor.orange },
    'EXPRESS_INTEREST': { color: AppColor.pink }
  };
  useEffect(() => {
    if (schedule && schedule.length > 0) {
      const arr = [];
      schedule.forEach((job) => {
        const { date, jobAvailabilityDetails } = job;
        if (jobAvailabilityDetails && jobAvailabilityDetails.length > 0) {
          jobAvailabilityDetails.forEach((item) => {
            const { startTime, endTime, shiftType, numberWorkers } = item;
            let { bookingDates } = item;
            bookingDates = bookingDates.filter(item => item.booking?.bookingStatus !== "CANCEL" && item.booking?.bookingStatus !== "REJECTED");
            let _bookingDates = [];
            if (bookingDates.length > 0 && numberWorkers > bookingDates.length) {
              for (let i = 0; i < (numberWorkers - bookingDates.length); i++) {
                const availableDate = {
                  booking: {
                    bookingStatus: BOOKING_STATUS.AVAILABLE
                  },
                  worker: {},
                  distance: null
                };
                _bookingDates = [..._bookingDates, availableDate];
              }
            }
            bookingDates = [...bookingDates, ..._bookingDates];
            let dateStartTime = new Date(`${date} ${startTime}`);
            let dateEndTime = new Date(`${date} ${endTime}`);

            const hoursStart = moment(dateStartTime).hours();
            const hoursEnd = moment(dateEndTime).hours();
            const nextDay = moment(date).add(1, 'days').format("MM-DD-YYYY");
            let isNextDay = false;
            if (shiftType === "EVENING") {
              if (hoursStart < 24 && hoursEnd <= 6) {
                dateEndTime = new Date(`${nextDay} ${endTime}`);
                isNextDay = true;
              }
              if (hoursStart < 6 && hoursEnd <= 6) {
                dateStartTime = new Date(`${nextDay} ${startTime}`);
                dateEndTime = new Date(`${nextDay} ${endTime}`);
              }
            }
            if (shiftType === "NIGHT") {
              if (hoursStart < 24 && hoursEnd <= 6) {
                dateEndTime = new Date(`${nextDay} ${endTime}`);
              }
              if (hoursStart < 6 && hoursEnd <= 6) {
                dateStartTime = new Date(`${nextDay} ${startTime}`);
                dateEndTime = new Date(`${nextDay} ${endTime}`);
                isNextDay = true;
              }
            }
            let start = moment(dateStartTime).format();
            let end = moment(dateEndTime).format();

            const range = parseInt(moment.range(dateStartTime, dateEndTime).diff("minutes"));
            const obj = {
              title: `${moment(`${date} ${startTime}`).format('HH:mm')} - ${moment(`${date} ${endTime}`).format('HH:mm')}`,
              start: start,
              end: end,
              color: bookingDates && bookingDates.length > 0 ? '#dee2e6' : '#FFFFFF',
              borderColor: bookingDates.length === 0 ? '#999' : '',
              bookingData: bookingDates,
              shiftType: shiftType,
              time: `${date} ${t(`shift.${shiftType}`)}, ${moment(`${date} ${startTime}`).format('HH:mm')} - ${moment(`${date} ${endTime}`).format('HH:mm')}`,
              numberWorkers: numberWorkers,
              numberOfBooked: bookingDates.filter(item => (item.booking.bookingStatus === "BOOKED") || (item.booking.bookingStatus === "WAITING") || (item.booking.bookingStatus === "EXPRESS_INTEREST")).length,
              date: date,
              jobAvailabilityId: item.jobAvailabilityId,
              range: range < 0 ? (range * -1) : range,
              isNextDay: isNextDay
            };
            arr.push(obj);
          })

        }

      });
      setEvents(arr);
    } else {
      setEvents([]);
    }
  }, [schedule]);

  useEffect(() => {
    if (reload) {
      reloadJob();
      setSelectedWeek(cacheSelectedWeek);
      reloadCalendar();
      setReload(false);
      setShowWorkerTag(false);
    }
  }, [reload]);

  useEffect(() => {
    if (workerBooking.length > 0) {
      let arr = [];
      if (jobType !== "SINGLE_WORKER") {
        workerBooking.map(wk => {
          if (!wk.booked) {
            const availableDate = {
              booking: {
                bookingStatus: BOOKING_STATUS.AVAILABLE
              },
              worker: wk.workerResponse,
              workerResponse: wk.workerResponse,
              distance: wk.workerResponse.distance,
              schedule: wk.schedule
            };
            arr.push(availableDate);
          }
        });
      }
    }
  }, [workerBooking, events]);
  const compare = (a, b) => {
    if (a.jobAvailabilityId < b.jobAvailabilityId) {
      return -1;
    }
    if (a.jobAvailabilityId > b.jobAvailabilityId) {
      return 1;
    }
    return 0;
  }
  const renderEventContent = (eventInfo) => {
    const { bookingData = [], shiftType, range, jobAvailabilityId, numberOfBooked, isNextDay } = eventInfo.event._def.extendedProps;
    let lastIndex = false;
    events.sort(compare);
    if (events[events.length - 1].jobAvailabilityId === jobAvailabilityId) {
      lastIndex = true;
    } else {
      lastIndex = false;
    }
    if (range <= 30 && range > 0) {
      return (
        <div className={`${classes.jobCalendarContainer} ${shiftType}`}>
          <div className={`${classes.jobCalendar}`}>
            <Box className='text-center' style={{ display: 'flex', justifyContent: 'space-around', height: range < 20 ? range < 15 ? '10px' : '14px' : '16px', fontSize: range < 15 ? '10px' : "", alignItems: range < 15 ? 'center' : '' }}>
              {renderShiftIcon(shiftType, true)}
              {((range > 20 && !lastIndex) || (range < 20 && lastIndex) || (range === 20)) || (range === 30) ? <div>{eventInfo.event.title}</div> : <></>}
            </Box>
            {(range <= 30 && range > 20) && bookingData.length === 0 && (
              <Box className='text-center' >
                Available
              </Box>
            )}
            {range === 30 && numberOfBooked === 1 && bookingData[0].worker.id &&
              <Box className='text-center'>
                <Tooltip title={`${bookingData[0].worker.firstName} ${bookingData[0].worker.lastName} is ${bookingData[0].booking.bookingStatus === "WAITING" ? t("bookingStatus.PENDING") : t(`bookingStatus.${bookingData[0].booking.bookingStatus}`)}`}>
                    <p style={{ width: '136px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '4px' }}>
                    {`${bookingData[0].worker.firstName} ${bookingData[0].worker.lastName}`} is {bookingData[0].booking.bookingStatus === "WAITING" ? t("bookingStatus.PENDING") : t(`bookingStatus.${bookingData[0].booking.bookingStatus}`)} </p>
                </Tooltip>
              </Box>}
            {range === 30 && numberOfBooked > 1 && <Box className='text-center'>
              {`Staff Numbers: ${numberOfBooked}`}
            </Box>}
            <Box className='text-center'>
              {
                bookingData.map((item, index) => {
                  const color = bookingColor[item.booking.bookingStatus] ? bookingColor[item.booking.bookingStatus].color : '';
                  return (<span key={index} style={{ color: color, marginLeft: 2 }}><i className="fas fa-circle" /></span>)
                }
                )
              }
            </Box>
          </div>
        </div>
      )
    } else {
      return (
        <div className={`${classes.jobCalendarContainer} ${shiftType}`}>
          <div className={`${classes.jobCalendar}`}>
            <Box className='text-center' style={{ display: 'flex', justifyContent: 'space-around', height: isNextDay ? 18 : '' }}>
              {renderShiftIcon(shiftType)}
              <div>{eventInfo.event.title}</div>
            </Box>
            {bookingData.length === 0 && (
              <Box className='text-center'>
                Available
              </Box>
            )}
            {numberOfBooked === 1 && bookingData[0].worker.id &&
              <Box className='text-center' style={{ height: "24px" }}>
                <Tooltip title={`${bookingData[0].worker.firstName} ${bookingData[0].worker.lastName} is ${bookingData[0].booking.bookingStatus === "WAITING" ? t("bookingStatus.PENDING") : t(`bookingStatus.${bookingData[0].booking.bookingStatus}`)}`}>
                  <p style={{ width: '136px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '4px' }}>
                    {`${bookingData[0].worker.firstName} ${bookingData[0].worker.lastName}`} is {bookingData[0].booking.bookingStatus === "WAITING" ? t("bookingStatus.PENDING") : t(`bookingStatus.${bookingData[0].booking.bookingStatus}`)} </p>
                </Tooltip>
              </Box>}
            {numberOfBooked > 1 && <Box className='text-center' style={{ color: '#fff' }}>
              {`Staff Numbers: ${numberOfBooked}`}
            </Box>}
            <Box className='text-center'>
              {
                bookingData.map((item, index) => {
                  const color = bookingColor[item.booking.bookingStatus] ? bookingColor[item.booking.bookingStatus].color : '';
                  return (<span key={index} style={{ color: color, marginLeft: 2 }}><i className="fas fa-circle" /></span>)
                }
                )
              }
            </Box>
          </div>
        </div>
      )
    }
  };
  const onClickBooking = async (eventInfo) => {
    // reloadCalendar();
    const { bookingData = [], shiftType, time = '', numberWorkers, jobAvailabilityId } = eventInfo.event._def.extendedProps;
    const request = {
      date: time.split(" ")[0].replaceAll("-", "/"),
      // shiftType: shiftType,
      jobAvailabilityId: jobAvailabilityId,
      jobId: jobId,
      page_number: 1,
      page_size: numberWorkers
    }
    let title = time.split(" ");
    title[0] = moment(title[0]).format('DD-MM-yyyy');
    setTitleBooking(title.join(' '));
    setSelectedDate(AppUtil.getDayOfWeek(moment(new Date(time.split(" ")[0])).day()));
    setSelectedShift(shiftType);
    setJobAvailabilityId(jobAvailabilityId);
    const result = await dispatch(getWorkerToBooking(request));
    let arr = [];
    const { payload } = result;
    console.log("payload get worker to booking job: ", payload);
    if (payload && payload.length > 0) {
      setWorkerBooking(payload);
      payload.map(wk => {
        if (!wk.booked) {
          const availableDate = {
            booking: {
              bookingStatus: BOOKING_STATUS.AVAILABLE
            },
            worker: wk.workerResponse,
            workerResponse: wk.workerResponse,
            distance: wk.workerResponse.distance,
            schedule: wk.schedule
          };
          arr.push(availableDate);
        }
      });
    }
    if (bookingData.length === 0) {
      setSelectedWorker({ bookingData: arr, time });
      setShowWorkerTag(true);
    } else {
      arr = arr.filter(item => bookingData.filter(item => item.worker.id && item).find(data => data.worker.id !== item.worker.id) && item);
      setSelectedWorker({ bookingData: [...arr, ...bookingData], time });
      setShowWorkerTag(true);
    }
  };

  useEffect(() => {
    if (weekNum) {
      setSelectedWeekNum(weekNum);
    }
  }, [weekNum]);
  const isBeforeCurrentTime = () => {
    if (events.length > 0 && jobAvailabilityId) {
      const now = moment().format('YYYY/MM/DD');
      const jobAvailabilitiy = events.find(item => item.jobAvailabilityId === jobAvailabilityId);
      if (jobAvailabilitiy) {
        const startTime = moment(jobAvailabilitiy.start).format("YYYY/MM/DD");
        if (startTime && moment(startTime).isSame(moment().format('YYYY/MM/DD'))) {
          const currentTime = moment().format();
          const startTime = moment(events.find(item => item.jobAvailabilityId === jobAvailabilityId).start).format();
          if (moment.range(currentTime, startTime).diff("minutes") > 30) {
            return false;
          } else {
            return true;
          }
         } else {
          if (moment(startTime).isBefore(now)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
      
    }
    // const now = moment().add(30, 'minutes');
    // const weekNum = selectedWeekNum;
    // const currentDay = moment().isoWeek(weekNum).isoWeekday(selectedDate).format('YYYY/MM/DD');
    // const startTime = moment(events.find(item => item.jobAvailabilityId === jobAvailabilityId).start).format("YYYY/MM/DD");
    // if (moment(currentDay).isSame(now.format('YYYY/MM/DD'))) {
    //   switch (selectedShift) {
    //     case 'MORNING':
    //         if (now.hours() >= 20 ) {
    //           return true;
    //         }
    //         break;
    //     case 'AFTERNOON':
    //         if (now.hours() >= 22 ) {
    //           return true;
    //         }
    //         break;
    //     case 'EVENING':
    //     case 'NIGHT':
    //         return false;
    //     default:
    //         break;
    //   }
    // }
    // return false;
  };

  const getEstimate = async (data) => {
    const { workerResponse: { yearsOfExperience: yearExp } } = data;
    const weekNum = selectedWeekNum;
    // const hours = calendar[selectedWeek]["hours"];
    const jobAvailabilitiy = jobAvailabilities.filter(item => item.id === jobAvailabilityId && item.dayOfWeek === selectedDate && item.shiftType === selectedShift)[0];
    const hours = moment(jobAvailabilitiy.endTime).diff(moment(jobAvailabilitiy.startTime), "hours", true);
    const currentJob = events.filter(eve => eve.jobAvailabilityId === jobAvailabilitiy.id)[0];
    const currentYear = moment(currentJob.date).year();
    setSelectedYear(currentYear);
    const params = {
      availabilities: [
        {
          date: moment().isoWeek(weekNum).isoWeekday(selectedDate).year(currentYear).format('yyyy/MM/DD'),
          hours: hours,
          shift: selectedShift
        }
      ],
      yearsOfExperience: yearExp
    }

    if (specialty && specialty.id) {
      params["specialtyId"] = specialty.id;
    }
    if (support && support.id) {
      params["supportId"] = support.id;
    }
    if (accreditation && accreditation.id) {
      params["accreditationId"] = accreditation.id;
    }
    const result = await dispatch(reduceCalculatePrice(params));
    const { payload } = result;
    if (payload) {
      setEstimate(payload);
      setShowOptionBooking(true);
    } else {
      setEstimate(null);
      setShowOptionBooking(false);
    }
  };

  const onClickBookWorker = (data) => {
    setSelectedWorkerBooking(data);
    selectedShift && getEstimate(data);
  };
  const handleBookWorker = async ({ workerId, scheduleId, specialtyId, supportId }) => {
    setIsLoading(true);
    const params = {
      isBooking: true,
      jobId: jobId,
      scheduleId: scheduleId,
      specialtyId: specialtyId,
      supportId: supportId,
      workerId: workerId,
      jobAvailabilityId: jobAvailabilityId,
      startTime: moment(events.find(item => item.jobAvailabilityId === jobAvailabilityId).start).year(selectedYear).format("YYYY/MM/DD HH:mm"),
      endTime: moment(events.find(item => item.jobAvailabilityId === jobAvailabilityId).end).year(selectedYear).format("YYYY/MM/DD HH:mm")
    }
    const result = await dispatch(bookWorkerForJob(params));

    const { payload } = result;
    if (typeof payload === "object") {
      reloadJob();
      setSelectedWeek(cacheSelectedWeek);
      reloadCalendar();
      setSelectedYear();
    }
    setShowOptionBooking(false);
    setIsLoading(false);
    setShowWorkerTag(false);
  };
  const confirmBookWorker = () => {
    const params = {
      workerId: selectedWorkerBooking.workerResponse.id,
      scheduleId: selectedWorkerBooking.schedule.id
    }
    if (specialty && specialty.id) {
      params["specialtyId"] = specialty.id;
    }
    if (support && support.id) {
      params["supportId"] = support.id;
    }
    handleBookWorker(params);
  };
  const renderShiftIcon = (shift, minIcon) => {
    let iconComponent;
    switch (shift) {
      case 'MORNING':
        iconComponent = MorningIcon;
        break
      case 'AFTERNOON':
        iconComponent = AfternoonIcon;
        break
      case 'EVENING':
        iconComponent = EveningIcon;
        break
      case 'NIGHT':
        iconComponent = NightIcon;
        break
      default:
        iconComponent = MorningIcon;
        break;
    }
    return <div
      className={`${classes.itemIcon} ${minIcon ? classes.svgSmall : classes.svgNormal} ${shift}`}
      style={{ maskImage: `url(${iconComponent})`, WebkitMaskImage: `url(${iconComponent})` }}
      // style={minIcon ? minStyleIcon : { height: '22px', width: '22px' }}
    />;
  };
  console.log('jobAvailabilityId', jobAvailabilityId);
  return (
    <Box className={classes.calendarPage}>
      <FullCalendar
        plugins={[timeGridPlugin]}
        initialView='timeGridWeek'
        weekends={true}
        events={events}
        eventContent={renderEventContent}
        eventClick={onClickBooking}
        validRange={dateRange}
        weekNumberCalculation="ISO"
        titleFormat={{}}
        allDaySlot={false}
        height={'auto'}
        headerToolbar={{
          left: '',
          center: '',
          right: ''
        }}
        dayHeaderFormat={(param) => (moment(param.date).format('ddd DD/MM'))}
        // slotEventOverlap={false}
      />
      <AppDialog
        open={showOptionBooking}
        onClose={() => setShowOptionBooking(false)}
        maxWidth="sm"
        title={t('title.estimatedPrice')}
      >
        <Box>
          {
            estimate && (
              <Box>
                <Box display="flex" justifyContent="center">
                  <Box className={classes.wrapEstimate}>
                    <Box flex="2 0 0px">
                      <Box >{t('label.time')}</Box>
                      <Box>
                        {
                          estimate.dayTypes.map((item, index) => {
                            if (index > 0) {
                              return null;
                           }
                            return (
                              <Box key={`day-type-${index}`}>
                                <Box className={classes.bold}>{t(`dayType.${item.dayType}`)}</Box>
                                <Box className="ml-4">
                                  {
                                    item.shifts.map((estimateShift, indexShift) => {
                                      return (
                                        <Box key={`estimate-shift-${indexShift}`}>
                                          <span className={classes.bold}>{t('label.hoursValue', { value: estimateShift.segmentHours ? estimateShift.segmentHours.toFixed(2) : (estimateShift.remainingHours ? estimateShift.remainingHours.toFixed(2) : 0) })}</span>
                                          <span>{` ${t(`shift.${estimateShift.shiftType}`)} at `}</span>
                                          {
                                            estimateShift.segmentPrice &&
                                            <span>{`$${AppUtil.formatMoney(estimateShift.segmentPrice.toFixed(2))}/hour`}</span>
                                          }
                                          {
                                            estimateShift.remainingPrice &&
                                            <span>{`$${AppUtil.formatMoney(estimateShift.remainingPrice.toFixed(2))}/hour`}</span>
                                          }
                                        </Box>
                                      )
                                    })
                                  }
                                </Box>
                              </Box>
                            )
                          })
                        }
                      </Box>
                    </Box>
                    <Box flex="1 0 0px">
                      <Box>{t('label.total')}</Box>
                      <Box className={classes.bold}>{`$${estimate.totalPrice}`}</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )
          }
          <Box className={classes.control}>
            <AppButton
              label={`${t("button.back")}`}
              mode="outlined"
              onClick={() => setShowOptionBooking(false)}
            />
            <AppButton
              label={`${t("button.book")}`}
              rounder
              onClick={confirmBookWorker}
              className='ml-2'
              disabled={isLoading || jobDetail.status === "DEACTIVATE"}
              loading={isLoading}
            />
          </Box>
        </Box>
      </AppDialog>
      <AppDialog
        title={titleBooking}
        open={showWorkerTag}
        onClose={() => { setShowWorkerTag(false); reloadJob(); setSelectedWeek(cacheSelectedWeek); reloadCalendar(); }}
        maxWidth="sm"
      >
        {
          selectedWorker && selectedWorker.bookingData.length > 0 ? selectedWorker.bookingData.map((item, index) => {
            if (item.worker.id && item.booking.bookingStatus !== "CANCEL") {
              return (
                <div key={index}>
                  <JobUserTag
                    userInfo={{ ...item.worker, bookingStatus: item.booking.bookingStatus, bookingId: item.booking.id, time: selectedWorker.time }}
                    renderShiftIcon={renderShiftIcon}
                    isCalendar={(item.booking.bookingStatus === "AVAILABLE" && !item.worker.id) || item.booking.bookingStatus !== "AVAILABLE"}
                    isBooking={(item.booking.bookingStatus === "AVAILABLE" && item.worker.id) ? true : false}
                    onAdd={() => onClickBookWorker(item)}
                    isCancel={((item.booking.bookingStatus !== "AVAILABLE" && item.booking.bookingStatus !== "CANCEL" && item.booking.bookingStatus !== "DONE" && item.booking.bookingStatus !== "ON_GOING") && item.worker.id) ? true : false}
                    isEndBooking={(item.booking.bookingStatus === 'ON_GOING') && item.worker.id ? true : false}
                    setReload={setReload}
                    isDisableButtonBook={jobAvailabilityId && isBeforeCurrentTime(selectedShift)}
                  />
                </div>
              )
            }
          }) : <div style={{ textAlign: "center" }}> No Worker to Booking </div>
        }
      </AppDialog>
    </Box>
  );
}

JobCalendar.propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  calendar: PropTypes.any,
  schedule: PropTypes.any,
  setShowBookingWorker: PropTypes.any,
  jobId: PropTypes.any,
  workersApplied: PropTypes.any,
  jobDetail: PropTypes.any,
  reloadCalendar: PropTypes.func,
  reloadJob: PropTypes.any,
  setSelectedWeek: PropTypes.any,
  cacheSelectedWeek: PropTypes.any,
  selectedYear: PropTypes.any
};

export default JobCalendar;
